export enum ActivityTypeEnum {
  ASSIGNMENT = "Assignment",
  SUPPORTED_PRACTICE = "Supported Practice",
  INSTRUCTION = "Instruction"
}
export default ActivityTypeEnum;
